module.exports = __webpack_public_path__ + "img/galileo_cn.b61ef10a.png";